const isProduction = process.env.REACT_APP_ENVIRONMENT_NAME === 'Production';
const BASENAME = process.env.REACT_APP_ROUTER_BASENAME || '/';
export { isProduction, BASENAME };
